import { projectDataType } from ".";

const othiData: projectDataType = {
  path: "othi",
  title: "Optimal Health Technologies Institute",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965320/Art-Site/Othi/othi-10-05-14-still-07_jkguwl.jpg",
  description:
    "A fictional video advertisement for a dystopian technology research company attempting to optimize humanity for productivity.",
  year: 2015,
  videos: ["https://vimeo.com/gisellezatonyl/ohti"],
  projectPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965320/Art-Site/Othi/othi-10-05-14-still-07_jkguwl.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965323/Art-Site/Othi/screen_shot_2017-02-07_at_102654_pm-u9956-fr_wg4mye.png",
  ],
};

export default othiData;
